import { useQueryUserDetailHeader } from '../../models/useQueryUserDetailHeader'

export interface IUseUserDetailHeaderPresenterParams {
  /** Route param — the FS/Page owns routing context (ADR-9) */
  userId: number
  /** False when another report config's header hook should fetch instead */
  enabled?: boolean
}

/**
 * Hook-only presenter (ADR-2): resolves the user's full name for the
 * detail breadcrumb "{Orders by user} / {user name}" (BHV-022). The v3
 * payload carries no Location-Department context — name-only render per
 * the HLD Open Question resolution.
 */
export const useUserDetailHeaderPresenter = ({
  userId,
  enabled = true,
}: IUseUserDetailHeaderPresenterParams) => {
  const { user, isLoading } = useQueryUserDetailHeader(userId, enabled)

  return {
    data: {
      userFullName: user?.fullName ?? null,
    },
    states: {
      isLoading,
    },
  }
}
